import { Component, OnInit } from "@angular/core";
import { ValidateService } from "../../services/validate.service";
import { AuthService } from "../../services/auth.service";
import { FlashMessagesService } from "angular2-flash-messages";
import { Router } from "@angular/router";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.css"],
})
export class LoginComponent implements OnInit {
  email: String;
  password: String;

  constructor(
    private validateService: ValidateService,
    private flashMessagesService: FlashMessagesService,
    private authService: AuthService,
    private router: Router
  ) {}

  ngOnInit() {}

  onLoginSubmit() {
    const user = {
      email: this.email,
      password: this.password,
    };

    // login user

    // suscribe user
    /*
    this.authService.authenticateUser(user).subscribe((data) => {
      if (data.success) {
        this.authService.StoreUserData(data.user);
        this.flashMessagesService.show("vous etes maintenant authentifie", {
          cssClass: "alert-success",
          timeout: 4000,
        });
        this.router.navigate(["/admin"]);
        console.log(data);
      } else {
        this.flashMessagesService.show(data.msg, {
          cssClass: "alert-danger",
          timeout: 4000,
        });
        this.router.navigate(["login"]);
      }
    });
    */

    if (
      user.email == "admin@kyowakirin.com" &&
      user.password == "naGLLgDY8sgLba2a"
    ) {
      console.log("success");
      this.router.navigate(["/admin"]);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/login/login.component.ts